import { createSelector } from 'reselect'
import { State } from 'index'

const campaignSelector = (state: State) => state.campaign

export const getConfirmCampaign = createSelector([campaignSelector], (state) => state.confirm)
export const getCampaigns = createSelector([campaignSelector], (state) => state.campaigns)
